import { KeyResult, KeyResultStatus } from "@/types";
import { cn } from "@/lib/utils";
import { dueStatusOf, daysSince, STALE_AFTER_DAYS } from "./okr-dates";
import { DueBadge } from "./DueBadge";

const shortDate = (iso: string) =>
    new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric" });

interface KrMetaBadgesProps {
    keyResult: KeyResult;
}

/** Weight, due date, and staleness cluster shared by compact and full KR rows. */
export function KrMetaBadges({ keyResult }: KrMetaBadgesProps) {
    const isActive = keyResult.status === KeyResultStatus.ACTIVE;
    const dueStatus = dueStatusOf(keyResult.dueDate, isActive);
    const staleDays = daysSince(keyResult.updatedAt);
    const isStale = isActive && staleDays !== null && staleDays >= STALE_AFTER_DAYS;

    return (
        <>
            {keyResult.weight != null && (
                <span className="font-mono text-[10px] text-muted-foreground shrink-0" title="Weight in the objective">
                    w{Math.round(keyResult.weight)}%
                </span>
            )}
            {keyResult.dueDate && (
                <span className="text-[10px] text-muted-foreground shrink-0">{shortDate(keyResult.dueDate)}</span>
            )}
            <DueBadge status={dueStatus} />
            {staleDays !== null && (
                <span
                    className={cn("text-[10px] shrink-0", isStale ? "text-amber-600 dark:text-amber-500" : "text-muted-foreground")}
                    title={isStale ? "Stale: the objective rollup relies on this number" : undefined}
                >
                    updated {staleDays === 0 ? "today" : `${staleDays}d ago`}
                </span>
            )}
        </>
    );
}
